import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function Select({ className, options, name, placeholder, onChange, value, defaultValue, disabled }) {
  return (
    <select
      className={classNames('select', className)}
      id={name}
      name={name}
      onChange={onChange}
      value={value || defaultValue || ''}
      disabled={disabled}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

Select.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.bool, PropTypes.string])
};
